module.exports = __webpack_public_path__ + "static/media/crypko_ai.7a35d500.png";